<template lang='pug'>
  i.svg-icon.svg-icon-line
    svg(
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(fill='#3AAE36' d='M97.04,84.102c0,6.335-5.161,11.472-11.525,11.472H14.441c-6.365,0-11.525-5.137-11.525-11.472V17.898 c0-6.336,5.16-11.472,11.525-11.472h71.073c6.364,0,11.525,5.136,11.525,11.472V84.102z')
      path(fill='#FFFFFF' d='M86.295,50.188c0.168-0.885,0.251-1.63,0.289-2.215c0.063-0.964-0.009-2.396-0.034-2.844 C85.662,29.679,69.633,17.37,49.99,17.37c-20.213,0-36.599,13.033-36.599,29.111c0,14.777,13.843,26.983,31.778,28.861 c1.096,0.114,1.887,1.104,1.765,2.199l-0.763,6.873c-0.173,1.561,1.439,2.695,2.854,2.014c15.152-7.313,24.212-14.836,29.624-21.354 c0.984-1.187,4.194-5.685,4.85-6.865C84.887,55.7,85.844,53.007,86.295,50.188z')
      path(fill='#3DAF36' d='M29.865,52.378V40.116c0-1.034-0.838-1.872-1.872-1.872l0,0c-1.034,0-1.872,0.838-1.872,1.872V54.25 c0,1.034,0.838,1.872,1.872,1.872h7.488c1.034,0,1.872-0.838,1.872-1.872l0,0c0-1.033-0.838-1.872-1.872-1.872H29.865z')
      path(fill='#3DAF36' d='M41.413,56.122h-0.818c-0.808,0-1.463-0.655-1.463-1.463V39.707c0-0.808,0.655-1.463,1.463-1.463h0.818 c0.808,0,1.463,0.655,1.463,1.463v14.953C42.875,55.467,42.221,56.122,41.413,56.122z')
      path(fill='#3DAF36' d='M56.541,40.116v8.635c0,0-7.476-9.752-7.59-9.88c-0.357-0.401-0.884-0.648-1.468-0.625 c-1.018,0.039-1.799,0.929-1.799,1.948V54.25c0,1.033,0.838,1.872,1.873,1.872l0,0c1.034,0,1.872-0.839,1.872-1.872v-8.583 c0,0,7.589,9.836,7.702,9.943c0.331,0.313,0.776,0.507,1.267,0.512c1.039,0.009,1.89-0.91,1.89-1.95V40.116 c0-1.034-0.839-1.872-1.872-1.872l0,0C57.38,38.244,56.541,39.082,56.541,40.116z')
      path(fill='#3DAF36' d='M74.326,40.116L74.326,40.116c0-1.034-0.838-1.872-1.871-1.872h-7.489c-1.034,0-1.872,0.838-1.872,1.872 V54.25c0,1.034,0.838,1.872,1.872,1.872h7.489c1.033,0,1.871-0.838,1.871-1.872l0,0c0-1.033-0.838-1.872-1.871-1.872h-5.617v-3.323 h5.617c1.033,0,1.871-0.838,1.871-1.873l0,0c0-1.034-0.838-1.872-1.871-1.872h-5.617v-3.323h5.617 C73.488,41.988,74.326,41.15,74.326,40.116z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
};

</script>
